import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { GetStatusDetailResult } from './get-status-detail.result';

@Injectable()
export class GetStatusDetailUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(id: string): Observable<GetStatusDetailResult> {
    this.state.setDetailLoading(true);

    return this.repository.getStatusDetail(id).pipe(
      tap((status) => {
        this.state.setSelectedStatus(status);
      }),
      map((status) => ({ status })),
      catchError((error) => {
        this.state.setError(error.message || 'Failed to load status detail');
        throw error;
      }),
      finalize(() => {
        this.state.setDetailLoading(false);
      }),
    );
  }
}
